//APLICAR CANVIS A DEV
// Initialize and add the map
import { MarkerClusterer, SuperClusterAlgorithm } from "https://cdn.skypack.dev/@googlemaps/markerclusterer@2.3.1";
async function initMap() {
    // Request needed libraries.
    //@ts-ignore
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerView } = await google.maps.importLibrary("marker");

    const infoWindow = new google.maps.InfoWindow({maxWidth: 400});

    const mapStyles = [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#212121"
            }
          ]
        },
        {
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#212121"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "administrative.country",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative.locality",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#bdbdbd"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#181818"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#1b1b1b"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#2c2c2c"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#8a8a8a"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#373737"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#3c3c3c"
            }
          ]
        },
        {
          "featureType": "road.highway.controlled_access",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#4e4e4e"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#3d3d3d"
            }
          ]
        }
    ];

    // The map
    var map = new google.maps.Map(document.getElementById("map"), {
        zoom: 8,
        center: { lat: 41.91961873505121, lng: 1.8887718626558707},
        streetViewControl: false,
        mapTypeControl: false,
        styles: mapStyles
    });

    const markerPromises = locations.map((point, i) => {

        // console.log(point);
        const label = point.name;
        const position = { lat: Number(point.lat), lng: Number(point.lng) };

        return new Promise((resolve) => {
          createCustomMarkerIcon(point.imatge, (customIconUrl) => {
            const marker = new google.maps.Marker({
              position,
              map: map,
              icon: {
                url: customIconUrl,
                //scaledSize: new google.maps.Size(50, 50),
              },
            });

            // Afegim el listener per obrir el InfoWindow
            marker.addListener("click", () => {

              // Contingut de la finestra d'informació
              const contentString = point.htmlInfo;

              // Establim el contingut de la finestra d'informació
              infoWindow.setContent(contentString);

              // Assignem la finestra d'informació al marcador
              infoWindow.open(map, marker);
            });
            resolve(marker);
          });
        });
    });
    // Un cop es creen tots els marcadors, inicialitza el cluster
    Promise.all(markerPromises).then((markers) => {
      const customRender = {
          render: function ({ count, position }) {
              const adjustedPosition = {
            lat: position.lat + 0.0001, // Ajusta cap amunt
            lng: position.lng + 0.0001  // Ajusta cap a la dreta
        };
              return new google.maps.Marker({
                  label: {
                    text: String(count), // Nombre total d’elements agrupats
                    color: "#000000",    // Assegura que sigui visible
                    fontSize: "30px",    // Mida més gran per provar si es mostra
                    fontWeight: "light",  // Per destacar el text
                    className: "map-label"
                  },
                  position,
                  icon: { url: "/media/img/markerclusterer/mgroc.svg" },
                  zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
              });
          }
      };

      // Inicialitza el MarkerClusterer amb SuperClusterAlgorithm i els marcadors
      new MarkerClusterer({
          algorithm: new SuperClusterAlgorithm({ minPoints: 2 }),
          markers,
          map,
          renderer: customRender
      });
    });

}

function createCustomMarkerIcon(icon, callback) {
  const canvas = document.createElement("canvas");
  canvas.width = 70;
  canvas.height = 82;
  const context = canvas.getContext("2d");

  const baseImage = new Image();
  const logoImage = new Image();

  // Carrega les dues imatges
  baseImage.src = "/media/img/markerclusterer/mblanc.svg"; // Globus
  logoImage.src = icon; // Logotip

  // Dibuixa les imatges una sobre l’altra quan totes dues estiguin carregades
  baseImage.onload = () => {
    context.drawImage(baseImage, 0, 0, 70, 82);
    logoImage.onload = () => {
      var distanciaSuperior = logoImage.height > 26 ? 18 : 26;
      context.drawImage(logoImage, 10, distanciaSuperior); // Ajusta la posició i mida del logotip
      callback(canvas.toDataURL()); // Retorna la imatge com a URL
    };
  };
}

initMap();
